import type { NotFoundPage, NotFoundPageQuery, QueryTermsAndConditionsQuery } from '@edwin-group/people-graphql';

import { initializeApollo, initializeApolloWithoutToken } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_TERMS_AND_CONDITIONS, QUERY_NOT_FOUND_PAGE } from '@edwin-group/people-graphql';

export async function fetchNotFoundPage() {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<NotFoundPageQuery>({
      query: QUERY_NOT_FOUND_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  if (!data) return { notFound: {} as NotFoundPage, error };

  const notFound = {
    ...(data.notFoundPage?.data?.attributes as NotFoundPage),
  };

  return { notFound, error };
}

export async function fetchTermsAndConditions() {
  const apolloClient = initializeApolloWithoutToken();

  const { data, error } = await requestHandler(
    apolloClient.query<QueryTermsAndConditionsQuery>({
      query: QUERY_TERMS_AND_CONDITIONS,
      fetchPolicy: 'cache-first',
    }),
  );

  if (!data) return { termsAndConditions: {}, error };

  const termsAndConditions = {
    ...data.termAndCondition?.data?.attributes,
  };

  return { termsAndConditions };
}
